/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports.Image = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Image = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Image, _React$PureComponent);

  function Image() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Image.prototype;

  _proto.componentDidMount = function componentDidMount() {
    require('../../css/images');
  };

  _proto.render = function render() {
    var _this$props = this.props,
        responsive = _this$props.responsive,
        href = _this$props.href,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["responsive", "href", "children"]);

    if (responsive) {
      props = (0, _helpers.mergeProps)(props, {
        className: 'img-responsive'
      });
    }

    var image = _react["default"].createElement("img", props, children);

    return href ? _react["default"].createElement("a", {
      href: href
    }, image) : image;
  };

  return Image;
}(_react["default"].PureComponent);

exports.Image = Image;

_defineProperty(Image, "propTypes", {
  responsive: _propTypes["default"].bool,
  href: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  src: _propTypes["default"].string.isRequired
});